<div class="spinner-container">
  <svg
    class="spinner"
    [class.spinner--indeterminate]="mode === ProgressMode.INDETERMINATE"
    [attr.viewBox]="spinnerViewBox"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle class="spinner__track" cx="32" cy="32" r="27"></circle>
    <!-- indeterminate mode -->
    <path
      *ngIf="mode === ProgressMode.INDETERMINATE"
      class="spinner__arc"
      d="M 32 5 A 27 27 0 0 1 59 32"
    ></path>
    <!-- determinate mode -->
    <circle
      *ngIf="mode === ProgressMode.DETERMINATE"
      class="spinner__arc transition"
      [attr.cx]="spinnerCenter"
      [attr.cy]="spinnerCenter"
      [attr.r]="spinnerRadius"
      [attr.stroke-dasharray]="spinnerCircumference"
      [attr.stroke-dashoffset]="spinnerCircumference * (1 - progress / 100)"
      transform="rotate(-90 32 32)"
    ></circle>
  </svg>
  <p *ngIf="showMessage && message" class="message" [class.message--delayed]="messageShowDelay > 0">
    {{ message }}
  </p>
</div>
